module.exports = __webpack_public_path__ + "img/default.6b914f9c.jpg";